import { faAndroid, faApple } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MDBBtn, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter } from "mdb-react-ui-kit";
import React from "react";

export default function Download() {
  const [show, setShow] = React.useState(false);
  React.useEffect(() => {
    const showDownload = e => {
      e.stopPropagation();
      e.preventDefault();
      setShow(true);
    };
    window.document.addEventListener('download', showDownload);
    return () => {
      window.document.removeEventListener('download', showDownload);
    };
  }, []);
  return (
    <MDBModal show={show} setShow={setShow} tabIndex='-1' className="modal-download">
      <MDBModalDialog centered size="sm">
        <MDBModalContent>
          <MDBModalBody>
            <h4>下载Linky</h4>
            <h5>一起记录美好生活</h5>
            <a href="https://apps.apple.com/au/app/apple-store/id1626782889" className="btn btn-outline-primary" target="_blank" rel="noreferrer nofollow noindex">
              <FontAwesomeIcon icon={faApple} />
              <span>App Store 下载</span>
            </a>
            <a href="https://res.hilinky.com.au/redbook.apk" className="btn btn-outline-primary" target="_blank" rel="noreferrer nofollow noindex">
              <FontAwesomeIcon icon={faAndroid} />
              <span>Android 下载</span>
            </a>
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn type="button" color="link" onClick={() => setShow(false)}>关闭</MDBBtn>
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
}